module.exports = __webpack_public_path__ + "img/label-bb1.e5be2902.png";